
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['user', 'payments', 'order', 'location', 'handoff', 'submitting']),
    paymentId() {
      if(this.selected) {
        return this.selected
      } else {
        let defaultPayment = null
        this.user.payments.map(p => {
          if(p.account.default) {
            defaultPayment = p.account.id
          }
        })
        return defaultPayment
      }
    }
  },
  data() {
    return {
      selected: null,
    }
  },
  methods: {
    usePayment(id) {
      this.selected = id
    },
    async removePayment(id) {
      await this.$api.deletePayment(id)
    },
    async submitOrder() {
      console.log('submitting')
      let payments = []
      let scba = {
        type: 'billingaccount',
        id: this.paymentId,
        phone: this.user.phone,
        amount: {
          total: this.order.totals.total,
          tip: this.order.totals.tip
        }
      }
      payments.push(scba)
      let order = await this.$api.submitOrder(payments)
      if(order) {
        let products = JSON.parse(JSON.stringify(this.order))
        if(products) {
          let purchases = []
          products.products.map(p => {
            purchases.push({
              name: p.name,
              price: p.cost.total,
              quantity: p.quantity,
              sku: p.product_id
            })
          })
          let transactionDetails = {
            ecommerce: {
              purchase: {
                actionField: {
                  id: products.id,
                  revenue: products.totals.total,
                  tax: products.totals.tax
                },
                storeNumber: this.location.id,
                zipCode: this.location.zip,
                products: purchases
              }
            }
          }
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push(transactionDetails)
        }
        this.$store.commit('setOrder', null)
        this.$store.commit('setSubmitting', false)
        this.$router.push(`/order/confirm?id=${order.id}`)
      } else {
        this.$store.commit('setSubmitting', false)
      }
    }
  },
  watch: {
    submitting(e) {
      if(e) {
        this.submitOrder()
      }
    }
  }
}
